import DeleteIcon from "@mui/icons-material/Delete";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import SearchIcon from "@mui/icons-material/Search";

import { ButtonBase } from "@mui/material";

import { GridColumn, GridItem, GridRow } from "commons/ui/Grid";
import AutocompleteInput from "commons/ui/input/AutocompleteInput";

import TitleFunctionsTopBlock from "components/ui/TitleFunctionsTopBlock";

import useCheckSectionErrors from "hooks/form/blocks/useCheckSectionErrors";
import useSectionProductHighlight from "hooks/form/blocks/useSectionProductHighlight";
import useTitleFunctionsTopBlock from "hooks/useTitleFunctionsTopBlock";

import { BlockEnum } from "types/enums";

function SectionProductHighlightForm({ blockId }: { blockId: BlockEnum }) {
    const { buttonDelete, onDeleteIconClick, productAutocompleteHook, formHook, dragAndDropHook } =
        useSectionProductHighlight();

    const { form } = formHook;

    useCheckSectionErrors({ formHook });

    const titleFunctionsTopBlockHook = useTitleFunctionsTopBlock({
        buttonDelete: buttonDelete,
    });

    return (
        <>
            <TitleFunctionsTopBlock titleFunctionsTopBlockHook={titleFunctionsTopBlockHook} />

            {titleFunctionsTopBlockHook.closedBlock && (
                <GridColumn>
                    <GridRow>
                        <GridItem className={"col-xs-24-24 title-margin"}>
                            <h2>Prodotti in evidenza</h2>
                        </GridItem>
                    </GridRow>

                    <GridRow alignItems="center">
                        <GridItem
                            className={
                                "col-xl-24-6 col-lg-24-8 col-xs-24-8 select-correlated-product"
                            }
                        >
                            <AutocompleteInput
                                autocompleteHook={productAutocompleteHook}
                                className={"autocomplete-no-margin"}
                                placeholder={"Seleziona i prodotti"}
                                startAdornment={<SearchIcon />}
                            />
                        </GridItem>

                        <GridItem className={"col-xl-24-18 col-lg-24-16 col-xs-24-16"}>
                            <GridRow>
                                {form.products.map((product, index) => {
                                    if (!product.toDelete) {
                                        const divProps: { [x: string]: any; className?: string } = {
                                            className: "col-xl-12-3 col-lg-12-6 col-xs-12-6",
                                        };

                                        if (dragAndDropHook !== undefined) {
                                            divProps.draggable = true;

                                            divProps.className +=
                                                " " + dragAndDropHook.classes[index]?.join(" ");

                                            divProps.onDragStart = () =>
                                                dragAndDropHook.onDragStart(index);
                                            divProps.onDragEnd = () =>
                                                dragAndDropHook.onDragEnd(index);
                                            divProps.onDragOver = (event: any) =>
                                                dragAndDropHook.onDragOver(event);
                                            divProps.onDragEnter = () =>
                                                dragAndDropHook.onDragEnter(index);
                                            divProps.onDragLeave = () =>
                                                dragAndDropHook.onDragLeave(index);
                                            divProps.onDrop = () => dragAndDropHook.onDrop(index);
                                        }

                                        return (
                                            <GridItem {...divProps} key={index}>
                                                <div className={"correlated-product"}>
                                                    <GridRow alignItems={"center"}>
                                                        <GridItem
                                                            className={
                                                                "col-xs-24-4 drag-indicator-icon"
                                                            }
                                                        >
                                                            <DragIndicatorIcon />
                                                        </GridItem>

                                                        <GridItem
                                                            className={"col-xs-24-17 product-name"}
                                                        >
                                                            {product.product_name}
                                                        </GridItem>

                                                        <GridItem
                                                            className={"col-xs-24-3 delete-icon"}
                                                        >
                                                            <ButtonBase
                                                                onClick={() =>
                                                                    onDeleteIconClick(
                                                                        product.product_id,
                                                                    )
                                                                }
                                                            >
                                                                <DeleteIcon />
                                                            </ButtonBase>
                                                        </GridItem>
                                                    </GridRow>
                                                </div>
                                            </GridItem>
                                        );
                                    }

                                    return null;
                                })}
                            </GridRow>
                        </GridItem>
                    </GridRow>
                </GridColumn>
            )}
        </>
    );
}

export default SectionProductHighlightForm;
